// src/pages/Protected/Perfil/components/ImageUpload/style.ts
import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
 
  // Novas classes
  hiddenInput: {
    display: 'none'
  },
  uploadLabel: {
    cursor: 'pointer',
    color: '#784A42',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  previewImage: {
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    borderRadius: '50%',
    marginTop: '10px'
  },
}))
